<script setup lang="ts">
import { Separator } from '@collector/shared-ui'
</script>

<template>
  <Separator
    class="h-full"
    vertical
  />
</template>
